import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import clsx from 'clsx';

import { createStyles } from "./styles";








var ProductRates = function ProductRates(_ref)




{var id = _ref.id,rates = _ref.rates,_ref$styles = _ref.styles,styles = _ref$styles === void 0 ? '' : _ref$styles,_ref$highlightColorSt = _ref.highlightColorStyle,highlightColorStyle = _ref$highlightColorSt === void 0 ? '' : _ref$highlightColorSt;
  var classes = createStyles();
  var RateItems = _mapInstanceProperty(rates).call(rates, function (_ref2) {var _context;var displayKey = _ref2.displayKey,value = _ref2.value;
    return /*#__PURE__*/(
      React.createElement("li", { className: classes.rateWrapper, key: _concatInstanceProperty(_context = "".concat(id, "-")).call(_context, displayKey) }, /*#__PURE__*/
      React.createElement("span", { className: classes.rateName }, displayKey), /*#__PURE__*/
      React.createElement("span", { className: clsx(classes.rateValue, highlightColorStyle) }, "$",
      Number(value).toFixed(2), "/mo")));



  });

  return /*#__PURE__*/React.createElement("ul", { className: clsx(classes.rates, styles) }, RateItems);
};

export default ProductRates;
//# sourceMappingURL=index.js.map